module.exports = __webpack_public_path__ + "img/T6-D-rc_23.ac336794.png";